import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import dayjs from "dayjs";
import { useAuth } from "../../context/AuthProvider";
import AdminMasterTable from "./AdminMasterTable";
import UserDetailView from "./UserDetailView";
import { isAdminRole } from "../../utils/roles";

const TimeTracker = () => {
  const { accessToken } = useAuth();
  const [decodedToken, setDecodedToken] = useState("");
  const [currentView, setCurrentView] = useState("master"); // 'master' or 'detail'
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [selectedDate, setSelectedDate] = useState(dayjs()); // Lift date state to parent

  // Decode token to get user info
  const getUserIdFromToken = () => {
    if (!accessToken) return null;

    try {
      const decoded = jwtDecode(accessToken);
      return decoded.id;
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  };

  const userId = getUserIdFromToken();

  const decodeToken = () => {
    try {
      const decoded = jwtDecode(accessToken);
      setDecodedToken(decoded);
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  };

  useEffect(() => {
    decodeToken();
  }, [accessToken]);

  const isAdmin = isAdminRole(decodedToken?.role);

  // Handle user selection from master table
  const handleUserSelect = (userId, userName) => {
    setSelectedUserId(userId);
    setSelectedUserName(userName);
    setCurrentView("detail");
  };

  // Handle back button click
  const handleBack = () => {
    setCurrentView("master");
    setSelectedUserId(null);
    setSelectedUserName("");
  };

  // Render based on user role and current view
  if (isAdmin) {
    if (currentView === "master") {
      return (
        <AdminMasterTable
          onUserSelect={handleUserSelect}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
        />
      );
    } else {
      return (
        <UserDetailView
          userId={selectedUserId}
          userName={selectedUserName}
          isAdmin={true}
          onBack={handleBack}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
        />
      );
    }
  } else {
    // Regular user - show only their detail view
    return (
      <UserDetailView
        userId={userId}
        userName=""
        isAdmin={false}
        onBack={null}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
      />
    );
  }
};

export default TimeTracker;
